import React, { useEffect } from "react";
import "./PrivacyNoticeDialog.css";

const PrivacyNoticeDialog = ({ isOpen, onClose }) => {
  // ダイアログ表示時の背景スクロール防止
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('dialog-open');
    } else {
      document.body.classList.remove('dialog-open');
    }

    // クリーンアップ: コンポーネントアンマウント時にクラスを削除
    return () => {
      document.body.classList.remove('dialog-open');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="privacy-notice-overlay">
      <div className="privacy-notice-dialog">
        <div className="privacy-notice-header">
          <h2>
            <span className="warning-icon">
              <i className="fas fa-exclamation-triangle"></i>
            </span>
            重要な注意事項
          </h2>
        </div>
        <div className="privacy-notice-content">
          <p>
            <strong>
              OG Matching はゼミ生とOGを繋ぎ、ゼミ生が就職活動における支援を受けやすくするためのアプリです。
            </strong>
          </p>
          <p className="privacy-detail">
            以下の利用規約を必ず読み、同意してから本アプリを利用してください。
          </p>
          
          <div className="terms-of-service-container">
            <h3 className="terms-title">OG Matching 利用規約</h3>
            <div className="terms-content">
              <p>
                この利用規約（以下「本規約」）は、「就活ゼミ」が運営するWebアプリ「OG Matching」（以下「本アプリ」）の利用に関する条件を定めるものです。本アプリの利用者（以下「利用者」）は、本規約に同意した上で本アプリを利用するものとします。
              </p>
              
              <h4>第1条（目的）</h4>
              <p>
                本アプリは、就活ゼミに所属する在学生（以下「ゼミ生」）と卒業生（以下「OG」）との交流を促進し、進路やキャリア形成を支援することを目的としています。
              </p>
              
              <h4>第2条（利用対象）</h4>
              <p>
                本アプリは、就活ゼミに在籍する学生および、運営が認めた関係者のみが利用できます。
              </p>
              
              <h4>第3条（個人情報の取扱い）</h4>
              <ol>
                <li>本アプリに掲載されているOGの連絡先などの個人情報は、ゼミ活動および正当な目的の範囲でのみ利用してください。</li>
                <li>OGの許可なく、連絡先情報を第三者に提供・共有することを禁止します。</li>
                <li>個人情報の無断転載・拡散（SNS等への掲載を含む）は厳禁とします。</li>
              </ol>
              
              <h4>第4条（禁止行為）</h4>
              <p>利用者は、以下の行為を行ってはなりません。</p>
              <ul>
                <li>営業、勧誘、宗教・政治活動など、本来の目的以外での利用</li>
                <li>OGまたは他の利用者への迷惑行為、誹謗中傷、プライバシーの侵害</li>
                <li>本アプリの運営を妨げる行為、および法令や公序良俗に反する行為</li>
              </ul>
              
              <h4>第5条（アカウント管理責任）</h4>
              <ol>
                <li>本アプリでは、メールリンクによる認証を用いてログインを行います。利用者は、自身のメールアカウントの管理に十分な注意を払い、第三者に不正利用されないよう責任を持って管理してください。</li>
                <li>利用者の不注意や第三者による不正アクセスにより発生した損害やトラブルについて、運営は一切の責任を負いません。</li>
                <li>万が一、不正ログインや情報漏えい等が判明した場合は、速やかに運営に報告してください。</li>
              </ol>
              
              <h4>第6条（利用停止・制限）</h4>
              <p>
                運営は、以下の場合、利用者に対して通知なくアカウントの停止・削除・制限を行うことができます。
              </p>
              <ul>
                <li>本規約に違反したと判断された場合</li>
                <li>不適切な利用が認められた場合</li>
                <li>その他、運営が不適切と判断する行為があった場合</li>
              </ul>
              
              <h4>第7条（免責事項）</h4>
              <ol>
                <li>OGとの連絡・やり取りに関する責任は、すべて当事者間にあります。</li>
                <li>本アプリに掲載の情報は利用者が登録したものであり、誤りや更新漏れが含まれる可能性があります。運営は情報の正確性・完全性を保証せず、それによる損害やトラブルについて責任を負いません。</li>
                <li>本アプリの利用により生じたトラブル・損害について、運営は一切の責任を負いません。</li>
              </ol>
              
              <h4>第8条（規約の変更）</h4>
              <p>
                運営は、必要に応じて本規約の内容を変更することがあります。変更後の規約は、本アプリ上に掲示された時点から効力を有します。
              </p>
            </div>
          </div>
          
          <p className="privacy-consideration">
            お互いに気持ちよく交流できるよう、思いやりと敬意を持ったコミュニケーションをお願いします。
          </p>
        </div>
        <div className="privacy-notice-footer">
          <button 
            onClick={onClose}
            className="privacy-notice-button"
          >
            同意して続ける
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyNoticeDialog;